export default {"src":"/_next/static/media/28.5fa67d5f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};